import { Box } from "@material-ui/core";
import ndbImg from "../../../images/contents/map/navaids/NDB.png";
import tacanImg from "../../../images/contents/map/navaids/TACAN.png"
import vorImg from "../../../images/contents/map/navaids/VOR.png"
import vorDmeImg from "../../../images/contents/map/navaids/VOR_DME.png"
import vorTacImg from "../../../images/contents/map/navaids/VOR_TAC.png"
import { LegendBoxList, LegendBoxListItem, LegendBoxListItemText } from "../../legend/LegendBoxComponents";
import { memo } from "react";

function LegendNavaids() {
  return (
    <Box>
      <LegendBoxList>
        <LegendBoxListItem>
          <img src={vorImg} alt="VOR"/><LegendBoxListItemText>VOR</LegendBoxListItemText>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <img src={vorDmeImg} alt="VOR/DME"/><LegendBoxListItemText>VOR/DME</LegendBoxListItemText>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <img src={vorTacImg} alt="VOR/TAC"/><LegendBoxListItemText>VOR/TAC</LegendBoxListItemText>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <img src={tacanImg} alt="TACAN"/><LegendBoxListItemText>TACAN</LegendBoxListItemText>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <img src={ndbImg} alt="NDB"/><LegendBoxListItemText>NDB</LegendBoxListItemText>
        </LegendBoxListItem>
      </LegendBoxList>
    </Box>
  )
}

export default memo(LegendNavaids);